import { Component } from "@angular/core";

@Component({
	selector: "app-orgadmin",
	templateUrl: "./orgadmin.component.html",
	styleUrls: ["./orgadmin.component.scss"]
})
export class OrgadminComponent {

}
